// Чи грати HLS нативно, а не через hls.js. Тільки справжній WebKit (iPhone,
// iPad, Safari на маку): Chrome теж відповідає «maybe» на canPlayType, але
// грає такий плейлист погано або ніяк — див. коментар до isWebKitBrowser у
// components/watch/Player.vue
export const isWebKitBrowser = () => {
  if (!import.meta.client) return false
  const ua = navigator.userAgent
  if (/iPhone|iPad|iPod/.test(ua)) return true
  if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return true // iPadOS
  return /Safari\//.test(ua) && !/Chrome\/|Chromium\/|Edg\/|OPR\/|Firefox\//.test(ua)
}

export const prefersNativeHls = (video) =>
  !!video?.canPlayType('application/vnd.apple.mpegurl') && isWebKitBrowser()
